"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.focusOnFirstError = focusOnFirstError;
exports.getFirstMessageError = getFirstMessageError;
exports.getFirstMessageErrorFromMultiForm = getFirstMessageErrorFromMultiForm;
exports.getFocusableElement = getFocusableElement;
exports.getText = getText;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _errorConstants = _interopRequireDefault(require("../../constants/errorConstants"));
var _Button = require("../../elements/button/Button");
var _scrollTo = require("../../utils/scroll/scrollTo");
var _formErrorSummaryLinkModule = _interopRequireDefault(require("./form-error-summary-link.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getText(totalValidationErrors) {
  return totalValidationErrors > 1 ? 'Go to first error' : 'Go to error';
}
function getFirstMessageError(parentForm) {
  if (parentForm) {
    return parentForm.querySelector("[data-testid=\"".concat(_errorConstants["default"].DATA_TESTID_ERROR, "\"]"));
  }
  return undefined;
}
function getFirstMessageErrorFromMultiForm() {
  return document.querySelector("[data-testid=\"".concat(_errorConstants["default"].DATA_TESTID_ERROR, "\"]"));
}
function getFocusableElement(parentForm, forValue) {
  return parentForm.querySelector("#".concat(forValue));
}
function getParentForm(el) {
  if (el && el.parentNode) {
    var parent = el.parentNode;
    if (parent && parent.tagName !== 'FORM') {
      parent = getParentForm(parent);
    }
    return parent;
  }
  return undefined;
}
function focusOnFirstError(evt, multiFormValidation) {
  var parentForm = getParentForm(evt.target);
  var firstMessageError = getFirstMessageError(parentForm);
  if (!firstMessageError && multiFormValidation) {
    var errorFieldOutsideOfParentForm = getFirstMessageErrorFromMultiForm();
    parentForm = getParentForm(errorFieldOutsideOfParentForm);
    firstMessageError = getFirstMessageError(parentForm);
  }
  if (firstMessageError) {
    var forValue = firstMessageError.getAttribute('for');
    var firstErroringFormField = getFocusableElement(parentForm, forValue);
    if (firstErroringFormField) {
      (0, _scrollTo.scrollToElement)(firstErroringFormField, true);
    } else {
      (0, _scrollTo.scrollToElement)(firstMessageError, true);
    }
  }
}
var FormErrorSummaryLink = function FormErrorSummaryLink(_ref) {
  var _ref$totalValidationE = _ref.totalValidationErrors,
    totalValidationErrors = _ref$totalValidationE === void 0 ? 0 : _ref$totalValidationE,
    _ref$hideFirstErrorLi = _ref.hideFirstErrorLink,
    hideFirstErrorLink = _ref$hideFirstErrorLi === void 0 ? false : _ref$hideFirstErrorLi,
    _ref$multiFormValidat = _ref.multiFormValidation,
    multiFormValidation = _ref$multiFormValidat === void 0 ? false : _ref$multiFormValidat;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.UnderlinedButton, {
    className: (0, _classnames["default"])(_defineProperty({}, _formErrorSummaryLinkModule["default"].hiddenLink, hideFirstErrorLink)),
    onClick: function onClick(evt) {
      return focusOnFirstError(evt, multiFormValidation);
    },
    "data-jlds": true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: getText(totalValidationErrors)
    })
  });
};
FormErrorSummaryLink.propTypes = {
  totalValidationErrors: _propTypes["default"].number,
  hideFirstErrorLink: _propTypes["default"].bool,
  multiFormValidation: _propTypes["default"].bool
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(FormErrorSummaryLink);